import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_antd@3.15.2@antd/es/col/index.js
// module id = 296
// module chunks = 0